import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonIcon from "@mui/icons-material/Person";
import BottomShopBag from "components/BottomShopBag";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { SyntheticEvent, useState } from "react";
import { Box } from "@mui/system";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import { IShoppingBagData, ISingleShoppingBagResponse } from "../../types/ShoppingBag";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}


function BottomNav({shoppingBagQuery}:Props) {
  const [searchParams] = useSearchParams();
  //const shopping_bag_open = searchParams.get("shopping_bag_open");
  const location = useLocation();
  const place_id = searchParams.get("place_id");
  const table = searchParams.get("table");
  const customOriginQrCode = searchParams.get("origin");

  const shoppingBag = shoppingBagQuery.data

  const paramsPlaceId = place_id
    ? place_id
    : shoppingBag && shoppingBag.place_id

  const tableNumber = table
    ? table
    : (shoppingBag && shoppingBag.table_number
      ? shoppingBag.table_number
      : -1)

  const paramsTable = table
    ? `&table=${table}`
    : (shoppingBag && shoppingBag.table_number
      ? `&table=${shoppingBag.table_number}`
      : '')

  const paramsCustomOrigin = customOriginQrCode
    ? `&origin=${customOriginQrCode}`
    :""

  const params =`?place_id=${paramsPlaceId}${paramsCustomOrigin}${tableNumber > -1 ? paramsTable : ''}`

  const [value, setValue] = useState("Início");

  const handleChange = (e: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (location.pathname !== "/" && location.pathname !== "/cardapio") ? (
    <Paper
      sx={{
        display: { sm: "block", md: "none" },
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
      }}
      elevation={3}
    >

      <BottomShopBag
        isShoppingBagRefetching={ shoppingBagQuery.isRefetching}
        isShoppingBagLoading={ shoppingBagQuery.isLoading }
      shoppingBagQuery={shoppingBagQuery}/>

      <BottomNavigation
        sx={{ backgroundColor: "#FB6B1C", color: "white" }}
        value={value}
        onChange={handleChange}
      >
        {/* <BottomNavigationAction label="Inicio" icon={<HomeIcon sx={{ color: 'white' }} />} component={Link} to={`/?place_id=${place_id ? place_id : placeInfo?.id }&table=${(shoppingBag !== null) && shoppingBag.length > 0 ? shoppingBag.table_number : table}`} /> */}
        <BottomNavigationAction
          sx={[
            {
              "&.Mui-selected": {
                color: "white",
                fontWeight: "bold",
              },
            },
          ]}
          label="Início"
          icon={<HomeIcon sx={{ color: "white" }} />}
          component={Link}
          to={`/delivery${params}`}
          value="Início"
        />
        <BottomNavigationAction
          sx={[
            {
              "&.Mui-selected": {
                color: "white",
                fontWeight: "bold",
              },
            },
          ]}
          label="Pedidos"
          icon={<ReceiptIcon sx={{ color: "white" }} />}
          component={Link}
          to={`/orders${params}`}
          value="Pedidos"
        />
        <BottomNavigationAction
          sx={[
            {
              "&.Mui-selected": {
                color: "white",
                fontWeight: "bold",
              },
            },
          ]}
          label="Perfil"
          icon={<PersonIcon sx={{ color: "white" }} />}
          component={Link}
          to={`/settings${params}`}
          value="Perfil"
        />
      </BottomNavigation>
    </Paper>
  ) : (
    <Box></Box>
  );
}

export default BottomNav;
